import React from "react";
import { Route, Routes as BrowserRoutes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { Routes } from "./utils/constants";
import RegisterForm from "./pages/Register/RegisterForm";
import RegisterFormSimple from "./pages/Register/RegisterFormSimple";
import ConfirmRegister from "./pages/Register/ConfirmRegister";
import RegisterEmailSent from "./pages/Register/RegisterEmailSent";
import Completed from "./pages/Register/Completed";
import Login from "./pages/Auth/Login";
import Mypage from "./pages/Mypage/MyPage";
import Layout from "./components/Layout";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import UserSetting from "./pages/Mypage/UserSetting/index";
import NotificationSetting from "./pages/User/Notification";
import EmailSetting from "./pages/User/Email";
import PasswordSetting from "./pages/User/Password";
import Logout from "./pages/Logout";
import FinistWithdrawal from "./pages/User/WithdRawal/finish";
import WithdRawal from "./pages/User/WithdRawal";
import WithdRawalConfirm from "./pages/User/WithdRawal/confirm";
import UserSettingConfirm from "./pages/Mypage/UserSetting/SettingConfirm";
import Survey from "./pages/Survey";
import OptOutNotification from "./pages/OptOutNotification";
import SurveyAnswer from "./pages/Survey/answer";
import ConfirmAnswer from "./pages/Survey/confirmAnswer";
import FinishAnswer from "./pages/Survey/answerFinish";
import SurveyMember from "./pages/Survey/member";
import Events from "./pages/Events";
import ResetPassword from "./pages/Auth/ResetPassword";
import CompletedResetPass from "./pages/Auth/CompletedResetPass";
import EmailChange from "./pages/Auth/EmailChange";
import SessionVideo from "./pages/SessionVideo";
import ConfirmError from "./pages/Confirm/ConfirmError";
import ConfirmSuccess from "./pages/Confirm/ConfirmSuccess";
import CreateUserError from "./pages/Error/CreateUserError";
import Massmedian from "./pages/Massmedian";
import Clipping from "./pages/Clipping";

export type IAppRoute = {
  path: string;
  element: React.ElementType;
};

const publicRoutes: IAppRoute[] = [
  {
    path: Routes.USERGUEST,
    element: Login,
  },
  {
    path: Routes.OPTOUTNOTIFICATION,
    element: OptOutNotification,
  },
  {
    path: Routes.WITHDRAWALFINISH,
    element: FinistWithdrawal,
  },
  {
    path: Routes.LOGOUT,
    element: Logout,
  },
  {
    path: Routes.REGISTER,
    element: RegisterForm,
  },
  {
    path: Routes.REGISTERSIMPLE,
    element: RegisterFormSimple,
  },
  {
    path: Routes.CONFIRM_REGISTER,
    element: ConfirmRegister,
  },
  {
    path: Routes.EMAIL_SENT,
    element: RegisterEmailSent,
  },
  {
    path: Routes.COMPLETED,
    element: Completed,
  },
  {
    path: Routes.LOGIN,
    element: Login,
  },
  {
    path: Routes.PASSWORDREMIND,
    element: ForgotPassword,
  },
  {
    path: Routes.RESET_PASS,
    element: ResetPassword,
  },
  {
    path: Routes.RESET_PASS_COMPLETED,
    element: CompletedResetPass,
  },
  {
    path: Routes.CREATEUSERERROR,
    element: CreateUserError,
  },
];

const authRoutes: IAppRoute[] = [
  {
    path: Routes.USER,
    element: Mypage,
  },
  {
    path: Routes.NOTIFICATION,
    element: NotificationSetting,
  },
  {
    path: Routes.USERSETTING,
    element: UserSetting,
  },
  {
    path: Routes.USERSETTINGCONFIRM,
    element: UserSettingConfirm,
  },
  {
    path: Routes.EMAILSETTING,
    element: EmailSetting,
  },
  {
    path: Routes.PASSWORDSETTING,
    element: PasswordSetting,
  },
  {
    path: Routes.WITHDRAWAL,
    element: WithdRawal,
  },
  {
    path: Routes.WITHDRAWALCONFIRM,
    element: WithdRawalConfirm,
  },
  {
    path: Routes.SURVEY,
    element: Survey,
  },
  {
    path: Routes.Events,
    element: Events,
  },
  {
    path: Routes.SURVEY_ANSWER,
    element:SurveyAnswer
  },
  {
    path: Routes.SURVEY_ANSWER_CONFIRM,
    element: ConfirmAnswer,
  },
  {
    path: Routes.SURVEY_ANSWER_FINISH,
    element: FinishAnswer,
  },
  {
    path: Routes.SURVEY_MEMBER,
    element:SurveyMember
  },
  {
    path: Routes.EMAIL_CHANGE,
    element: EmailChange,
  },
  {
    path: Routes.SESSION_VIDEO,
    element: SessionVideo
  },
  {
    path: Routes.CONFIRMSUCCESS,
    element: ConfirmSuccess
  },
    {
    path: Routes.CONFIRMERROR,
    element: ConfirmError,
  },
   {
    path: Routes.MASSMEDIAN,
    element: Massmedian,
  },
  {
    path: Routes.CLIPPING,
    element: Clipping,
  },
];

const AppRoutes: React.FC = () => {
  return (
    <BrowserRoutes>
      <Route element={<Layout />}>
        {publicRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={<route.element />} />
        ))}
        {authRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <ProtectedRoute>
                <route.element />
              </ProtectedRoute>
            }
          />
        ))}
      </Route>
      <Route path="*" element={!window.location.pathname.includes("/user/images") ? <Navigate to={Routes.USERGUEST} replace={true} /> : <></>} />
    </BrowserRoutes>
  );
};

export default AppRoutes;
